import useApiPrivateClient from "../../hooks/useApiPrivateClient";
import { CreateLanguageData } from "./language.requests";
import { Language } from "./language.responses";

const useLanguageService = () => {
  const apiPrivateClient = useApiPrivateClient();

  const createLanguage = (languageData: CreateLanguageData) => {
    return apiPrivateClient.post<Language>("/languages", languageData);
  };

  const getLanguages = () => {
    return apiPrivateClient.get<Language[]>("/languages");
  };

  const getLanguagesByRouteId = (routeId: number) => {
    return apiPrivateClient.get<Language[]>(`/languages/${routeId}`);
  };

  const deleteLanguage = (code: string) => {
    return apiPrivateClient.delete<void>(`/languages/${code}`);
  };

  return {
    createLanguage,
    getLanguages,
    getLanguagesByRouteId,
    deleteLanguage,
  };
};

export default useLanguageService;
